import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'dayjs';

Vue.use(Vuex);

//  需要维护的状态
const state = {
  stuStatus: [
    {label: '到', key: '3', type: 'green', name: '已到', alias: null, changeable: true},
    {label: '旷', key: '0', type: 'danger', name: '旷课', changeable: true},
    {label: '迟', key: '2', type: 'warning', name: '迟到', changeable: true},
    {label: '退', key: '4', type: 'lightblue', name: '早退', changeable: true},
    {label: '假', key: '1', type: 'blue', name: '请假', changeable: true},
    {label: '公', key: '5', type: 'green', name: '公假', changeable: false}
  ],
  roleList: {
    'xtgly': '99999',
    'jwcld': '90001',
    'jwy': '90002',
    'gjdr': '90003',
    'school': '8099',
    'tw': '80101',
    'school_2': '8099',
    'jbxxcx': '80105',
    'xbfdy': '303',
    'xbsj': '30100',
    'xbsjjl': '30103',
    'xbsjqj': '30104',
    'bzr': '101'
  },
  roles: [],
  loading: false,
  teacherMark: {
    2: '已面谈',
    3: '已电话联系',
    4: '已QQ通知',
    5: '已反馈家长'
  },
  leaveMarkType: {
    1: '因事或因病请假',
    2: '偶尔偷懒不上课',
    3: '经常性不上课',
    4: '其他'
  },
  leaveMarkReason: {
    5: '学生自身',
    6: '学生家庭',
    7: '教师教学',
    8: '学校管理',
    9: '其他'
  },
  unLookedList: [],
  navTitle: '',
  user: {},
  validImgUrl: '',
  signDetail: {},
  recordDetail: {},
  showBar: true,
  levelType: {
    A: '承认旷课',
    B: '不确定旷课',
    C: '否认旷课',
    D: '用户忙',
    E: '拨打失败',
    F: '无效号码'
  },
  finishStatusType: {
    0: '已接',
    1: '拒接',
    2: '无法接通',
    3: '主叫号码不可用',
    4: '空号',
    5: '关机',
    6: '占线',
    7: '停机',
    8: '未接',
    9: '主叫欠费',
    10: '呼损',
    11: '黑名单'
  },
  checkType: {
    0: '正常考勤',
    1: '免听',
    2: '休学',
    3: '退学'
  },
  classList: [],
  recordDate: {},
  stuMarkList: {
    index: 0,
    list: [],
    allList: []
  },
  type: '', // 0 今日校园 1 微信
  date: moment().format('YYYY-MM-DD'),
  leftNavBar: [], // type属性: 0 图标 1 文字 2 图标和文字
  rightNavBar: [] // type属性: 0 图标 1 文字 2 图标和文字
};

const mutations = {
  initNavTitle: function (state, data) {
    state.navTitle = data;
  },
  initRightNavBar: function (state, data) {
    state.rightNavBar = data;
  },
  initLeftNavBar: function (state, data) {
    state.leftNavBar = data;
  },
  initDate(state, data) {
    state.date = data;
  },
  initRecordDate(state, data) {
    state.recordDate = data;
  },
  initLoading: function (state, data) {
    state.loading = data;
  },
  type(state, data) {
    state.type = data;
  },
  user(state, data) {
    state.user = data;
  },
  validImgUrl(state, data) {
    state.validImgUrl = data;
  },
  signDetail(state, data) {
    state.signDetail = data;
  },
  recordDetail(state, data) {
    state.recordDetail = data;
  },
  initUnLookedList(state, data) {
    state.unLookedList = data;
  },
  initClassList(state, data) {
    state.classList = data;
  },
  initStuMarkList(state, data) {
    state.stuMarkList = data;
  },
  initShowBar(state, data) {
    state.showBar = data;
  }
};

Object.keys(state).forEach(k => {
  mutations[k] = (state, data) => {
    state[k] = data;
  };
});

export default new Vuex.Store({
  state,
  mutations
});
